import { AutoComplete, Button, Checkbox, Divider, Input, Popover } from "antd";
import React, { useEffect, useState } from "react";
import { ColumnsProps, FilterComponentProps } from "../DynamicTableV3";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import CheckboxGroupSelelect from "./CheckboxGroupSelelect";
import { filterData } from "../../../../Helper/TableHelper";
const CheckboxGroup = Checkbox.Group;

const StringFilterComponent = ({
  colProp,
  options,
  dataSource,
  filtersState: filterState,
  allColumnProps,
}: FilterComponentProps) => {
  const [checkedList, setCheckedList] = useState<CheckboxValueType[]>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [columnOption, setColumnOption] = useState<any[]>([]);
  const [sourceOptions, setSourceOptions] = useState<any[]>([]);
  const [autoComplateOptions, setAutoComplateOptions] = useState<any[]>([]);

  useEffect(() => {
    const data = Array.from(
      new Set(
        dataSource
          ?.map((e) => e[colProp.key])
          .filter((v) => v !== null && v !== undefined && v !== "")
      )
    ).map((v) => ({ value: toAutoValue(v) }));

    setSourceOptions(data);
    setAutoComplateOptions(data);
  }, [dataSource]);

  useEffect(() => {
    if (!options.value) {
      setSearchValue("");
      setCheckedList([]);
    }
  }, [options]);

  const onSearchOptions = (e: string) => {
    if (e === "" && checkedList.length === 0) {
      options.filterApplyCallback(null);
    } else {
      options.filterApplyCallback({
        searchText: e,
        checkedList,
      });
    }
    setSearchValue(e);
  };
  
  const stripCurrentFilter = (filters: any, currentKey: string) => {
    if (!filters) return filters;
    const newFilters: any = {};
    Object.keys(filters).forEach((key) => {
      if (key !== currentKey) {
        newFilters[key] = filters[key];
      }
    });
    return newFilters;
  };

  const toAutoValue = (v: any) => {
    if (typeof v === "boolean") return v ? "true" : "false";
    return v;
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
      <AutoComplete
        key={colProp.key + "filter"}
        style={{ width: 200 }}
        value={searchValue}
        options={autoComplateOptions}
        onDropdownVisibleChange={(open) => {
          if (!open) return;

          const filteredState = stripCurrentFilter(filterState, colProp.key);
          const result = filterData(dataSource, filteredState, allColumnProps);

          const options = Array.from(
            new Set(
              result
                ?.map((r) => r[colProp.key])
                .filter((v) => v !== null && v !== undefined && v !== "")
            )
          ).map((v) => ({ value: toAutoValue(v) }));

          setAutoComplateOptions(options);
        }}
        onSearch={(e) => {
          setAutoComplateOptions(
            sourceOptions.filter((o) =>
              o.value?.toString().toLowerCase().includes(e.toLowerCase())
            )
          );
        }}
        onChange={(e) => {
          setSearchValue(e);

          if (e === "" && checkedList.length === 0) {
            options.filterApplyCallback(null);
          } else {
            options.filterApplyCallback({
              searchText: e,
              checkedList,
            });
          }
        }}
        placeholder={`Search by ${colProp.label}`}
      />

      <Popover
        content={
          <CheckboxGroupSelelect
            datasource={columnOption}
            checkList={checkedList}
            onChange={(list) => {
              setCheckedList(list);
              if (searchValue === "" && list.length === 0) {
                options.filterApplyCallback(null);
              } else {
                options.filterApplyCallback({
                  searchText: searchValue,
                  checkedList: list,
                });
              }
            }}
          />
        }
        placement="bottom"
        trigger="click"
        onVisibleChange={(open) => {
          if (open) {
            const filteredState = stripCurrentFilter(filterState, colProp.key);

            const res = filterData(dataSource, filteredState, allColumnProps);

            if (res) {
              setColumnOption(
                Array.from(
                  new Set(
                    res
                      .map((e) => e[colProp.key])
                      .filter(
                        (v) =>
                          v !== null &&
                          v !== undefined &&
                          v !== "" &&
                          (!searchValue ||
                            v
                              .toString()
                              .toLowerCase()
                              .includes(searchValue.toLowerCase()))
                      )
                  )
                ).map((v) => v.toString())
              );
            }
          } else {
            setColumnOption([]);
          }
        }}
      >
        <Button
          icon={<i className="pi pi-filter" style={{ color: "slateblue" }} />}
          type="text"
          shape="circle"
        />
      </Popover>
    </div>
  );
};

export default StringFilterComponent;
